import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { pageKey, toNumber, MappingService } from 'src/app/services/mapping.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { IClassSchedule } from 'src/app/interfaces/enrollment';
import { ConvertService } from 'src/app/services/convert.service';
import { Observable } from 'rxjs';
import { ClassroomStore } from 'src/app/stores/enrollment/classroom.store';

@Component({
  selector: 'app-update-schedule',
  templateUrl: './update-schedule.component.html',
  styleUrls: ['./update-schedule.component.scss']
})
export class UpdateScheduleComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  form: FormGroup;
  subject: AbstractControl;
  code: AbstractControl;
  limit: AbstractControl;
  tutor: AbstractControl;
  shift: AbstractControl;
  session: AbstractControl;
  note: AbstractControl;

  filteredSubjectStates: Observable<any[]>;
  filteredTutorStates: Observable<any[]>;
  filteredSessionStates: Observable<any[]>;
  filteredShiftStates: Observable<any[]>;

  process: boolean = true;
  constructor(public dialogRef: MatDialogRef<UpdateScheduleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public list: List,
    public store: ClassroomStore,
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      subject: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      code: [null, Validators.required],
      limit: [30, Validators.required],
      tutor: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      shift: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      session: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      note: [null],
    });
    this.subject = this.form.controls['subject'];
    this.code = this.form.controls['code'];
    this.limit = this.form.controls["limit"];
    this.tutor = this.form.controls["tutor"];
    this.shift = this.form.controls["shift"];
    this.session = this.form.controls["session"];
    this.note = this.form.controls["note"];
  }

  async ngOnInit() {
    this.buildForm();

    const subjectData = await this.list.fetchList(this.ds.subjectRef());
    const tutorData = await this.list.fetchList(this.ds.tutorRef());
    const shiftData = await this.list.fetchList(this.ds.shiftRef());

    this.filteredSubjectStates = MappingService.autoComplete(this.subject, subjectData, "name");
    this.filteredTutorStates = MappingService.autoComplete(this.tutor, tutorData, "fullname");
    this.filteredShiftStates = MappingService.autoComplete(this.shift, shiftData, "name");

    const { code, note, limit, subjectKey, sessionKey, shiftKey, tutorKey } = this.data;

    const selectedSubject = subjectData.filter(m => m.key === subjectKey)[0];
    const selectedTutor = tutorData.filter(m => m.key === tutorKey)[0];
    const selectedShift = shiftData.filter(m => m.key === shiftKey)[0];

    this.form.patchValue({
      code,
      note,
      limit,
      subject: selectedSubject,
      tutor: selectedTutor,
      shift: selectedShift,
    })

    if (shiftKey) {

      const sessionData = await this.list.fetchList(this.ds.sessionByShiftRef(shiftKey));
      this.filteredSessionStates = MappingService.autoComplete(this.session, sessionData, "name");

      const selectedSession = sessionData.filter(m => m.key === sessionKey)[0];
      this.session.patchValue(selectedSession);
    }

    this.process = false;
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  displayItemFullName(item: any): string {
    return item ? item.fullname : item;
  }

  async onSelectShift(event) {
    const { value } = event.option;
    this.session.patchValue(null);

    if (value) {

      const sessionData = await this.list.fetchList(this.ds.sessionByShiftRef(value.key));
      this.filteredSessionStates = MappingService.autoComplete(this.session, sessionData, "name");
    }
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { code, note, limit, subject, session, shift, tutor } = f;
      const { created_at, created_byRef, created_by, page_key, isDelete, status, totalEnroll } = this.data;
      const item: IClassSchedule = {
        key: this.data.key,
        page_key: page_key,
        created_at: created_at,
        created_byRef: created_byRef,
        created_by: created_by,
        updated_at: new Date(),
        updated_byRef: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        updated_by: this.auth.user.uid,
        isDelete: isDelete,
        status: status,
        keyword: ConvertService.toCapitalize(`${code.trim()}`),

        code,
        note,
        totalEnroll,
        limit: toNumber(limit),
        subjectKey: subject.key,
        subjectRef: this.ds.subjectRef().doc(`${subject.key}`).ref,
        tutorKey: tutor.key,
        tutorRef: this.ds.tutorRef().doc(`${tutor.key}`).ref,
        shiftKey: shift.key,
        shiftRef: this.ds.shiftRef().doc(`${shift.key}`).ref,
        sessionKey: session.key,
        sessionRef: this.ds.sessionRef().doc(`${session.key}`).ref,

        classRoomKey: this.store.selectedClass.key,
        classRoomRef: this.ds.classRoomRef().doc(`${this.store.selectedClass.key}`).ref,
      };

      this.store.updateSchedule(item, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Schedule has been updated successfully.', 'done', { duration: 2000 });
          this.form.reset();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });

    }
  }

}
